import { EnvelopeIcon } from "@heroicons/react/24/solid";
import Link from "next/link";

import { GoogleLoginButton } from "@/components/google-login-button";
import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";

import { Button } from "ui/core/button";

export const LoginMaskContent = () => {
  const { t, lang } = useLang();
  return (
    <div className="max-w-md">
      <div className="mt-3 text-center sm:mt-5">
        <h3 className="text-base font-semibold leading-6 text-gray-900">
          {t.blockDialog.login.title}
        </h3>
        <div className="mt-2">
          <p className="text-sm text-gray-500">
            {t.blockDialog.login.description[0]}{" "}
            <Link
              href={`/${lang}${links.authLogin}`}
              className="font-bold text-sky-700"
            >
              {t.blockDialog.login.login}
            </Link>
            {t.blockDialog.login.description[1]}
          </p>
        </div>
      </div>
      <div className="mt-5 max-sm:space-y-3 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Link href={`/${lang}${links.authSignup}`}>
          <Button className="w-full py-2">
            <span className="flex items-center justify-center gap-1.5">
              <EnvelopeIcon className="h-5 w-5" />
              {t.blockDialog.login.emailSignup}
            </span>
          </Button>
        </Link>
        <GoogleLoginButton className="h-9 w-full">
          {t.blockDialog.login.googleSignup}
        </GoogleLoginButton>
      </div>
    </div>
  );
};
